import React from 'react'

const AccordionRight = () => (
    <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 17L9 9L1 0.999999" strokeWidth="2" />
    </svg>
)

export default AccordionRight